// src/features/Gnn/postNewsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { set } from 'date-fns';

const initialState = {
  country: 'All',
  regions: ['All'],
  categories: 'Internal Posts',
  description: '',
  uploadProgress: null,
  uploadStarted: false,
  attachments: [],
  newsId: null,
  isTwinWinFormOpen: false,
};

const gnnSlice = createSlice({
  name: 'gnn',
  initialState: initialState,
  reducers: {
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    setAttachments: (state, action) => {
      state.attachments = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
      state.regions = action.payload === 'All' ? ['All'] : [];
    },
    setRegions: (state, action) => {
      state.regions = action.payload;
    },
    resetPostNews: (state) => {
      state.categories = 'Internal Posts';
      state.regions = ['All'];
      state.country = 'All';
      state.description = '';
      state.attachments = [];
    },
    setNewsAttachmentUploadProgress: (state, action) => {
      const { progress, uploadStarted } = action.payload;
      state.uploadStarted = uploadStarted;
      state.uploadProgress = progress;
    },
    setNewsId: (state, action) => {
      state.newsId = action.payload;
    },
     setTwinWinFormOpen: (state, action) => {
      state.isTwinWinFormOpen = action.payload;
    },
  },
});

export const { setNewsAttachmentUploadProgress } = gnnSlice.actions;
export const { setCategories, setCountry, setRegions, resetPostNews, setDescription, setAttachments, setNewsId ,setTwinWinFormOpen} =
  gnnSlice.actions;
export const selectPostOptions = (state) => state.gnn;

export const selectNewsUploadProgress = (state) => state.gnn.uploadProgress;
export const selectNewsUploadStarted = (state) => state.gnn.uploadStarted;
export const selectNewsId = (state) => state.gnn.newsId;
export const selectTwinWinForm = (state) => state.gnn.isTwinWinFormOpen;

export default gnnSlice.reducer;
